import types from '../types';

const REDUCER_NAME = 'LISTING';
export const INIT = `${REDUCER_NAME}/INIT`;
export const SET_CURRENT_PAGE = `${REDUCER_NAME}/SET_CURRENT_PAGE`;
export const SET_FILTERS = `${REDUCER_NAME}/SET_FILTERS`;
export const SET_PAGINATION = `${REDUCER_NAME}/SET_PAGINATION`;
export const SET_IS_LOADING = `${REDUCER_NAME}/SET_IS_LOADING`;
export const SET_IS_LOADING_MORE = `${REDUCER_NAME}/SET_IS_LOADING_MORE`;
export const SET_ITEMS = `${REDUCER_NAME}/SET_ITEMS`;
export const SET_SEARCH_VALUE = `${REDUCER_NAME}/SET_SEARCH_VALUE`;

/**
 * @param {types.State} payload
 * @returns {{payload: types.State], type: string}}
 */
export const initAction = payload => {return {
    payload,
    type: INIT
}};

/**
 * @param {types.Filter[]} payload
 * @returns {{payload: types.Filter[], type: string}}
 */
export const setFiltersAction = payload => {return {
    payload,
    type: SET_FILTERS
}};

/**
 * @param {types.Product[]} payload
 * @returns {{payload: types.Product[], type: string}}
 */
export const setItemsAction = payload => {return {
    payload,
    type: SET_ITEMS
}};

/**
 * @param {string} payload
 * @returns {{payload: string, type: string}}
 */
export const setSearchValueAction = payload => {return {
    payload,
    type: SET_SEARCH_VALUE
}};

/**
 * @param {number} payload
 * @returns {{payload: number, type: string}}
 */
export const setCurrentPageAction = payload => {return {
    payload,
    type: SET_CURRENT_PAGE
}};

/**
 * @param {types.Pagination} payload
 * @returns {{payload: types.Pagination, type: string}}
 */
export const setPaginationAction = payload => {return {
    payload,
    type: SET_PAGINATION
}};

/**
 * @param {boolean} payload
 * @returns {{payload: boolean, type: string}}
 */
export const setIsLoadingAction = payload => {return {
    payload,
    type: SET_IS_LOADING
}};

/**
 * @param {boolean} payload
 * @returns {{payload: boolean, type: string}}
 */
export const setIsLoadingMoreAction = payload => {return {
    payload,
    type: SET_IS_LOADING_MORE
}};
